import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const deploymentFrequencyReportEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-deployment-frequency-report-entrypoint" */ './src/ui/index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
